"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TableColumnHeaderDisplayType;

(function (TableColumnHeaderDisplayType) {
  TableColumnHeaderDisplayType["raw"] = "raw";
  TableColumnHeaderDisplayType["scaleLegend"] = "scaleLegend";
  TableColumnHeaderDisplayType["weightingBar"] = "weightingBar";
})(TableColumnHeaderDisplayType = exports.TableColumnHeaderDisplayType || (exports.TableColumnHeaderDisplayType = {}));